// src/context/actions/authActions.js
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_USER,
} from "../types/authTypes";

// إجراء تسجيل الدخول بنجاح
export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

// إجراء تسجيل الدخول بالفشل
export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

// إجراء تسجيل الخروج
export const logout = () => ({
  type: LOGOUT,
});

// إجراء تعيين المستخدم
export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});
